export default "__VITE_ASSET__BoXDOyME__"